import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

export default function DepositButton() {
  const { user } = useAuth();
  const navigate = useNavigate();

  if (!user) return null;

  return (
    <button
      onClick={() => navigate('/deposit')}
      title="Make a Deposit"
      style={{
        position: 'fixed', bottom: 92, left: 24,
        background: 'linear-gradient(135deg,#10b981,#059669)',
        border: 'none', borderRadius: 14,
        padding: '10px 18px',
        color: '#fff', fontWeight: 700, fontSize: 14,
        cursor: 'pointer', zIndex: 9990,
        display: 'flex', alignItems: 'center', gap: 8,
        boxShadow: '0 4px 20px rgba(16,185,129,0.4)',
        transition: 'transform 0.2s, box-shadow 0.2s',
        fontFamily: 'var(--font-body)',
      }}
      onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-2px)'; e.currentTarget.style.boxShadow = '0 6px 28px rgba(16,185,129,0.5)'; }}
      onMouseLeave={e => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = '0 4px 20px rgba(16,185,129,0.4)'; }}
    >
      <span style={{ fontSize: 18 }}>💰</span>
      <span>Make Deposit</span>
    </button>
  );
}
